import React from 'react';
import { Info, AlertTriangle, CheckCircle, Zap } from 'lucide-react';
interface CalloutProps {
  type: 'info' | 'warning' | 'success' | 'highlight';
  title: string;
  content: string;
}
export function Callout({
  type,
  title,
  content
}: CalloutProps) {
  const config = {
    info: {
      icon: Info,
      bg: 'bg-blue-50 dark:bg-blue-950/30',
      border: 'border-blue-200 dark:border-blue-900',
      text: 'text-blue-800 dark:text-blue-200',
      iconColor: 'text-blue-600 dark:text-blue-400'
    },
    warning: {
      icon: AlertTriangle,
      bg: 'bg-amber-50 dark:bg-amber-950/30',
      border: 'border-amber-200 dark:border-amber-900',
      text: 'text-amber-800 dark:text-amber-200',
      iconColor: 'text-amber-600 dark:text-amber-400'
    },
    success: {
      icon: CheckCircle,
      bg: 'bg-emerald-50 dark:bg-emerald-950/30',
      border: 'border-emerald-200 dark:border-emerald-900',
      text: 'text-emerald-800 dark:text-emerald-200',
      iconColor: 'text-emerald-600 dark:text-emerald-400'
    },
    highlight: {
      icon: Zap,
      bg: 'bg-purple-50 dark:bg-purple-950/30',
      border: 'border-purple-200 dark:border-purple-900',
      text: 'text-purple-800 dark:text-purple-200',
      iconColor: 'text-purple-600 dark:text-purple-400'
    }
  };
  const style = config[type];
  const Icon = style.icon;
  return <div className={`my-6 rounded-lg border p-4 ${style.bg} ${style.border}`} data-id="element-239">
      <div className="flex items-start gap-3" data-id="element-240">
        <Icon className={`mt-0.5 h-5 w-5 shrink-0 ${style.iconColor}`} data-id="element-241" />
        <div data-id="element-242">
          <h4 className={`font-semibold ${style.text}`} data-id="element-243">{title}</h4>
          <div className={`mt-1 text-sm leading-relaxed ${style.text} opacity-90`} data-id="element-244">
            {content}
          </div>
        </div>
      </div>
    </div>;
}